import cx from "classnames"
import { Publicity } from "components/Publicity"
import { useBreakpoints } from "hooks/useBreakpoints"

export const TwoColLayout = ({ main, sidebar, publicityName }) => {
  const { lg } = useBreakpoints()

  return (
    <div className="lg:space-y-8">
      <div
        className={
          "space-y-6 pb-4 lg:pb-20 lg:grid lg:space-y-0 lg:gap-x-6 lg:grid-cols-[minmax(0,1fr)_328px]"
        }
      >
        <main>{main}</main>
        <aside
          className={cx(
            "fixed bottom-0 left-0 w-full bg-white py-2 px-5 z-10 space-y-6 empty:hidden shadow-[0px_-2px_2px_rgba(0,0,0,0.1)] lg:static lg:p-0 lg:bg-transparent lg:z-0 lg:shadow-none",
          )}
        >
          <div className="sticky top-44 space-y-12">
            {lg ? (
              <Publicity name={publicityName?.desktop ?? "vertical"} />
            ) : null}
            <div>{sidebar}</div>
          </div>
        </aside>
      </div>
      {!lg ? <Publicity name={publicityName?.mobile ?? "vertical"} /> : null}
    </div>
  )
}
